export const adjustmentLineValues = {adjustmentLineName: 'Override Sell Price Per Unit Adjustment',};

export default adjustmentLineValues;
